var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSwipeMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1308",
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1309"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1310"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20h6V6h-6V2H2v20h14Zm0-12h1v10h-1ZM7 18H5v-2h2Zm0-4H5v-2h2Zm3 4H8v-2h2Zm0-4H8v-2h2Zm3 4h-2v-2h2Zm0-4h-2v-2h2Zm1-8v2H4V4h10Z",
    fill: "#f899c8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwipeMachine);
export default __webpack_public_path__ + "static/media/icon-swipe-machine.7d55eed124af41125e82555cf6a9eaa2.svg";
export { ForwardRef as ReactComponent };